"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firekit = require("./firekit");

var _firekit2 = _interopRequireDefault(_firekit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (path) {
  return (0, _firekit2.default)().database.ref("config/public/" + path).once('value').then(function (snapshot) {
    return snapshot.val();
  });
};